import { Card, CardBody, Col } from "reactstrap";
import { ProjectCreatedTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ReactApexChart from "react-apexcharts";
import { RevenueGrowth } from "../../../../Data/General/Widgets/Chart";

const ProjectCreated = () => {
  return (
    <Col xl="6" lj="12" className="box-col-6 xl-50">
      <Card>
        <CommonCardHeader title={ProjectCreatedTitle} />
        <CardBody>
          <div className="chart-container skill-chart">
            <div id="revenuegrowth-2">
              <ReactApexChart options={RevenueGrowth} series={RevenueGrowth.series} type="area" height={320} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProjectCreated;
